export const BILL_TYPE = {
  APPLICATION_FEE: 'APPLICATION_FEE',
  FEE_ESTIMATE: 'FEE_ESTIMATE',
  INVOICE: 'INVOICE'
}

const billingTypeOptions = [
  { value: 'CHARGE', label: 'Charge' },
  { value: 'DISCOUNT', label: 'Discount' }
]

const billingUnitOptions = [
  { id: 'Pages', label: 'Pages' },
  { id: 'Hours', label: 'Hours' },
  { id: 'Each', label: 'Each' }
]

const billTypeMap = {
  [BILL_TYPE.APPLICATION_FEE]: 'Application Fee',
  [BILL_TYPE.FEE_ESTIMATE]: 'Fee Estimate',
  [BILL_TYPE.INVOICE]: 'Invoice'
}

const billTypeOptionsAll = [
  { value: BILL_TYPE.APPLICATION_FEE, label: 'Application Fee' },
  { value: BILL_TYPE.FEE_ESTIMATE, label: 'Fee Estimate' },
  { value: BILL_TYPE.INVOICE, label: 'Invoice' }
]

const billTypeOptions = [
  { value: BILL_TYPE.FEE_ESTIMATE, label: 'Fee Estimate' },
  { value: BILL_TYPE.INVOICE, label: 'Invoice' }
]

const billTypeOptionsApplicationFeeOnly = [{ value: BILL_TYPE.APPLICATION_FEE, label: 'Application Fee' }]

function getBillTypeOptions({ type = 'withoutApplicationFee' } = {}) {
  if (type === 'withApplicationFee') return billTypeOptionsAll
  if (type === 'onlyApplicationFee') return billTypeOptionsApplicationFeeOnly
  return billTypeOptions
}

const paymentMethodMap = {
  ONLINE: 'Online',
  IN_PERSON: 'In person'
}

const billStepperArray = ['Review', 'Payment']

const getBillStepperArray = () => {
  return billStepperArray
}

export function getApplicationFeeLineItems(applicationFeeAmount) {
  return [
    {
      type: 'CHARGE',
      description: 'Application Fee',
      quantity: 1,
      unit: '',
      price: applicationFeeAmount,
      tax: 0
    }
  ]
}

export {
  billingTypeOptions,
  billingUnitOptions,
  billTypeMap,
  billTypeOptions,
  billTypeOptionsAll,
  getBillTypeOptions,
  paymentMethodMap,
  billStepperArray,
  getBillStepperArray
}
